<template lang="pug">
  div
    el-row(type='flex')
      el-col(:span="8").container-input
        app-label(label="Nº do Processo:", :required="false")
        el-input.input(
          v-model="filtro.numeroProcesso"
          @blur="whitespace('nome')"
        )

      el-col(:span="8").container-input
        app-label(label="Gleba", :required="false")
        el-input.input(
          v-model="filtro.gleba"
          @blur="whitespace('nome')"
        )

      el-col(:span="8")
        app-label(label="Situação:", :required="false")
        el-select.input#prioridade(
          class="select",
          v-model="filtro.status",
          placeholder="Selecione",
          value-key="id"
        )
          el-option(
            v-for="item in statusList",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )

      el-col(:span="8")
        app-label(label="Município:", :required="false")
        el-select.input#prioridade(
          class="select",
          v-model="filtro.municipio",
          placeholder="Selecione",
          value-key="id"
        )
          el-option(
            v-for="item in municipiosList",
            :key="item.id",
            :label="item.nome",
            :value="item"
          )
</template>

<script>
import AppLabel from '@/components/AppLabel'
import { mapActions } from 'vuex'

export default {
  components: {
    AppLabel
  },

  props: {
    filtro: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      municipiosList: [],
      statusList: ['Em andamento', 'Aguardando retificação']
    }
  },

  methods: {
    ...mapActions({
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual'
    }),

    whitespace (field) {
      if (this.filtro[field]) {
        this.filtro[field] = this.filtro[field].trim()
      }
    }
  },

  mounted: async function () {
    this.municipiosList = await this.findMunicipiosByEstadoAtual()
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.container {
  display: flex;
  flex-direction: row;
  padding: 5px;
}

.container-input {
  margin-right: 20px;
  margin-top: 0px;
  margin-bottom: 10px;
}

.select {
  width: 100%;
}

.el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.el-date-editor >>> .el-range-separator {
  width: 20%;
}

.el-date-editor >>> .el-picker-panel__body {
  margin-left: 130px;
}

.el-date-editor
  >>> .el-picker-panel__body-wrapper
  >>> .el-picker-panel__sidebar {
  width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/components/PesquisaAvancadaArrecadacao.vue